import { OwaDate, getTimestamp } from 'owa-datetime';

const overflowIdPrefix = 'overflowIndicator_';

/**
 * Returns overflow indicator id corresponding to a date
 */
export default function getOverflowIndicatorId(date: OwaDate): string {
    return overflowIdPrefix + getTimestamp(date);
}

export function isOverflowIndicatorId(id: string): boolean {
    return id && id.substring(0, overflowIdPrefix.length) == overflowIdPrefix;
}
